import * as React from 'react';

import AppState from '../../AppState';
import { EmbeddedQuery } from '../../shared/EmbeddedQueryParser';
import Footer from '../Footer/Footer';
import Main from '../Main';
import Topbar from '../Topbar';
import css from './MainLayout.css';

export interface LayoutProps {
  appState: AppState;
  children: React.ReactElement;
  embeddedQuery?: EmbeddedQuery;
}

interface MainLayoutProps extends LayoutProps {}

export default class MainLayout extends React.Component<MainLayoutProps, {}> {
  render() {
    const {
      appState,
      children,
      embeddedQuery: { embed },
    } = this.props;
    const showFooter = !appState.store.isShowroom();

    if (embed) {
      return children;
    }

    const { footer } = appState.navigationState;

    return (
      <div className={css.MainLayout}>
        <Topbar appState={appState} translation={appState.translation.layout.topBar} />
        <Main className={css.content}>{children}</Main>
        {showFooter && (
          <Footer
            data={footer}
            homeUrl={appState.navigationState.homeUrl}
            storeContext={appState.storeResponse.storeContext}
          />
        )}
      </div>
    );
  }
}
